import * as React from 'react';
import moment from 'moment';

import StatusLabel from 'components/status-label/StatusLabel';
import ActionButton from 'components/buttons/action-button/ActionButton';

import RealmOutfitWMCLink from '../realm-outfit-wmc-link/RealmOutfitWMCLink';
import { STATUS_LABEL_MAPPING } from '../realm-outfits-table/RealmOutfitsTable';

import { __t, applyTranslations } from 'utils/language';
import {
  REALM_OUTFIT_STATUS_APPROVED,
  REALM_OUTFIT_STATUS_DECLINED,
  REALM_OUTFIT_STATUS_OFFLINE,
  REALM_OUTFIT_STATUS_PENDING,
  REALM_OUTFIT_STATUS_PUBLISHED,
  REALM_OUTFIT_STATUS_UNPUBLISHED
} from 'utils/realm-outfits';
import { getDisplayDate } from 'utils/date';

import './outfit-review-info.scss';

applyTranslations(require('./outfit-review-info.i18n.json'));

import { RealmOutfit } from 'types';

const EDITABLE_STATES = [REALM_OUTFIT_STATUS_PENDING, REALM_OUTFIT_STATUS_UNPUBLISHED];
const NO_ACTION_STATUES = [REALM_OUTFIT_STATUS_DECLINED, REALM_OUTFIT_STATUS_OFFLINE];

type Props = {
  outfit: RealmOutfit,
  creatorWmcLink: string | null,
  isBrandCreative?: boolean,
  onEditOutfit?: ((outfitId: number) => void) | null,
  onUnpublishOutfit?: (outfitId: number) => void
};

const OutfitReviewInfo = ({ isBrandCreative, outfit, creatorWmcLink, onEditOutfit, onUnpublishOutfit }: Props) => {
  const renderHeaderUnit = (label: string, component) => (
    <div>
      <div className="outfit-review-info__label">{label}</div>
      <div className="outfit-review-info__value">{component || '-'}</div>
    </div>
  );

  const renderActionButton = () => {
    let label = __t('outfit_review_header.buttons.unpublish_outfit');
    let buttonColor;
    let action;
    let disabled = false;

    const isOutfitPublishedButNotLive = outfit.status === REALM_OUTFIT_STATUS_APPROVED
      && moment().isBefore(moment(outfit.publishedFrom), 'day');

    const isOutfitPublishedAndLive = outfit.status === REALM_OUTFIT_STATUS_PUBLISHED
      && moment().isSameOrAfter(moment(outfit.publishedFrom), 'day');

    if (NO_ACTION_STATUES.includes(outfit.status)) {
      return null;
    }

    if (EDITABLE_STATES.includes(outfit.status) && !isOutfitPublishedAndLive) {
      label = __t('outfit_review_header.buttons.edit');
      buttonColor = 'secondary';
      action = onEditOutfit;
    }

    if (isOutfitPublishedButNotLive) {
      disabled = true;
    }

    const OutfitActionButton = (
      <ActionButton
        color={buttonColor || 'primary'}
        disabled={disabled}
        onClick={action || onUnpublishOutfit}
        className="outfit-review-info__action-btn"
      >
        {label}
      </ActionButton>
    );

    return onEditOutfit
      ? OutfitActionButton
      : null;
  };

  return (
    <div>
      <div className="outfit-review-info__main-container">
        {renderHeaderUnit(__t('outfit_review_header.labels.date_of_submission'), getDisplayDate(outfit.createdAt))}
        {renderHeaderUnit(__t('outfit_review_header.labels.date_of_review'), getDisplayDate(outfit.reviewedAt))}
        {!isBrandCreative && renderHeaderUnit(__t('outfit_review_header.labels.status_of_outfit'),
          <StatusLabel
            size="nano"
            type={STATUS_LABEL_MAPPING[outfit.status]}
            label={__t(`collabary_common.status.${outfit.status}`)}
          />
        )}
        {renderHeaderUnit(__t('outfit_review_header.labels.num_of_items'), outfit.numberOfItems)}
        {renderHeaderUnit(__t(`outfit_review_header.labels.${isBrandCreative ? 'zalando_link' : 'wmc_link'}`), outfit.wmcShortLink || creatorWmcLink ? (
          <RealmOutfitWMCLink
            outfitLink={outfit.wmcShortLink}
            creatorOutfitsLink={creatorWmcLink}
          />
        ) : null)}
        {renderHeaderUnit(__t('outfit_review_header.labels.outfit_id'), outfit.emOutfitId)}
      </div>
      {renderActionButton()}
    </div>

  );
};

export default OutfitReviewInfo;
